"use client";

import { Role } from "@prisma/client";
import PatientsOverview from "@/app/(components)/specifics/pages/Overview/items/PatientsOverview";
import UsersOverview from "@/app/(components)/specifics/pages/Overview/items/UsersOverview";
import { UserStore } from "@/app/stores/UserStore";
import { ViewStore } from "@/app/stores/ViewStore";
import { TKey } from "@/app/translations/TKey";
import { T } from "@/app/translations/Translations";
import { DefaultProps } from "@/app/types/DefaultProps";
import styles from "./Overview.module.css";

type Props = DefaultProps & {};

export default function Overview(props: Props) {
  const { lang } = props.params;
  const user = UserStore((state) => state.user);

  const isAdmin = user?.role === Role.ADMIN;
  const isAdminView = ViewStore((state) => state.isAdminView);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>{T(TKey.OVERVIEW, lang)}</h1>
      </div>

      <div className={styles.grid}>
        {isAdmin && isAdminView && <UsersOverview lang={lang} />}
        {!isAdminView && <PatientsOverview lang={lang} />}
      </div>
    </div>
  );
}
